import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaskService } from 'src/app/core/service/task.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';
import { IntlService } from '@progress/kendo-angular-intl';

@Component({
  selector: 'app-task-detail-followup-list',
  templateUrl: './task-detail-followup-list.component.html',
  styleUrls: ['./task-detail-followup-list.component.scss']
})
export class TaskDetailFollowUpListComponent implements OnInit
{

  @Input() public taskId: number;
  @Input() public caseId: number;
  @Input() public channelId: number;
  @Input() public memberId: number;

  @Output() public followUpTaskAdded = new EventEmitter();

  /**
   * Is it a new task?
   */
  public isNewTask = false;
  public loading = false;
  public data = [];

  constructor(
    private taskService: TaskService,
    private messageHandlerService: MessageHandlerService,
    public intl: IntlService)
  {
  }

  public ngOnInit(): void
  {
    this.loadData();
  }

  /**
   * Open the new task dialog
   */
  public createTask(): void
  {
    this.isNewTask = true;
  }

  /**
   * Method called after a new task has been added.
   */
  public afterTaskAdded(): void
  {
    this.isNewTask = false;
    setTimeout(() =>
    {
      this.loadData();
      this.followUpTaskAdded.emit();
    });
  }

  /**
   * Load follow-up tasks to grid view.
   */
  public loadData(): void
  {
    this.data = [];
    this.loading = true;
    this.taskService.getTasksForFollowUpTask(this.memberId, this.taskId).subscribe({
      next: (data) =>
      {
        data.forEach(d =>
        {
          d.openedOn = new Date(d.openedOn);
          d.dueDate = d.dueDate != null ? new Date(d.dueDate) : null;
        });
        this.data = sortBy(data, ['dueDate'], ['desc']);
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      },
      complete: () =>
      {
        this.loading = false;
      }
    });
  }
}
